import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../assets/css/components/accordion.css'

class Accordion extends Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: this.props.isOpen || false }
  }

  handleClick = ()=> {
    this.setState({ isOpen: !this.state.isOpen })
  }

  getStatus = ()=> {
    return this.state.isOpen ? 'open' : ''
  }

  render() {
    return(
      <div className={`accordion-section ${this.getStatus()}`}>
        <button className='toggle'>toggle</button>
        <span className='dot'><span className='dot-text'>{this.props.dotText}</span></span>
        <div className="sectionhead" onClick={this.handleClick}>
          <span className='title'>{this.props.title}</span>
        </div>
        <div className="articlewrap">
          <div className="article">
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

const { arrayOf, bool, string, object } = PropTypes
Accordion.propTypes = {
  isOpen: bool,
  dotText: string,
  title: string.isRequired,
  children: arrayOf(object).isRequired
}

export default Accordion
